import { useCallback, useMemo } from 'react';
import { debounce } from 'lodash';
import { toAssigneeSelectOption } from './AssigneeSelect.utils';
export function useDebouncedLoadOptions(loadAssignees) {
    const debouncedLoadAssignees = useMemo(() => debounce(async (inputValue, callback) => {
        const assignees = await loadAssignees(inputValue);
        callback(assignees.map(toAssigneeSelectOption));
    }, 300), [loadAssignees]);
    return useCallback((inputValue) => {
        return new Promise((resolve) => debouncedLoadAssignees(inputValue, resolve));
    }, [debouncedLoadAssignees]);
}
